module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/modules/_iterators.js
// module id = 25
// module chunks = 0